import { batch } from 'react-redux';
import { store } from './store';

/*-- Import reset actions for reset redux store --*/
import { resetMessageBox } from './actions/messageBoxActions';
import { resetNotificationBox } from './actions/notificationBoxActions';
import { hideLoadingScreen } from './actions/loadingScreenActions';
import { resetUserDetail } from './actions/userDetailsActions';
import { resetWebDataCollection } from './actions/webDataCollectionActions';
import { resetPromotionItems } from './actions/promotionItemsActions';
import { resetItemCart } from './actions/itemCartActions';
import { resetPreference } from './actions/preferenceActions';
import { resetUtilityDataCollection } from './actions/utilityDataCollectionActions';
import { resetUtilityCart } from './actions/utilityCartActions';
import { resetTrackingDetail } from './actions/trackOrderDetailAction';
import { resetNexusRegistrationDetail } from './actions/nexusRegistrationDetailActions';
import { resetProductMagnifier } from './actions/productMagnifierActions';
import { resetAgeVerification } from './actions/ageVerificationActions';
import { resetAgeGate } from './actions/ageGateActions';
import { resetOrderPromotionDetails } from './actions/orderPromotionActions';
import { resetOrderFreeIssuePromotionDetails } from './actions/orderFreeIssuePromotionActions';
import { resetNexusRedemption } from './actions/nexusRedemptionAction';
import { resetInsideNotificationStripe, resetOutsideNotificationStripe } from './actions/notificationStripeActions';
import { resetPreferenceModal } from './actions/preferenceModalActions';
import { resetUserRedirect } from './actions/userRedirectActions';
import { resetCalculatedPromotionResult } from './actions/calculatedPromotionResultActions';
import { resetQueueManager } from './actions/queueManagerActions';
import { jkoaPurchaseNo } from './actions/jkoaPurchaseAction';
import { resetCheckout } from './actions/checkoutAction';
import { resetWelcomePageTiles } from './actions/welcomePageTilesAction';
import { resetOrderData } from './actions/orderDataAction';
import { resetPromoCodeData } from './actions/promoCodeAction';
import { resetAlgonomyData } from './actions/algonomyActions';
import { resetLoyaltyRegistrationDetail } from './actions/V2_0/loyaltyRegistrationDetailActions';


const storeResetFunction = (exceptUserData, exceptCartRelatedDetails) => {
    batch(() => {
        store.dispatch(resetMessageBox());
        store.dispatch(resetNotificationBox());
        store.dispatch(hideLoadingScreen());
        store.dispatch(resetUtilityDataCollection());
        store.dispatch(resetUtilityCart());
        store.dispatch(resetTrackingDetail());
        store.dispatch(resetProductMagnifier());
        store.dispatch(resetAgeGate());
        store.dispatch(resetOrderPromotionDetails());
        store.dispatch(resetOrderFreeIssuePromotionDetails());
        store.dispatch(resetNexusRedemption());
        store.dispatch(resetPromoCodeData());

        store.dispatch(resetInsideNotificationStripe());
        //store.dispatch(resetOutsideNotificationStripe());
        store.dispatch(resetPreferenceModal());
        // store.dispatch(resetUserRedirect());
        store.dispatch(resetCalculatedPromotionResult());
        store.dispatch(resetQueueManager());
        // store.dispatch(resetWelcomePageTiles()); 
        store.dispatch(resetAlgonomyData());

        if (!exceptUserData) {
            store.dispatch(resetUserDetail());
        }

        if (!exceptCartRelatedDetails) {
            store.dispatch(resetPreference());
            store.dispatch(resetWebDataCollection());
            store.dispatch(resetPromotionItems());
            store.dispatch(resetItemCart());
            store.dispatch(resetNexusRegistrationDetail());
            store.dispatch(resetLoyaltyRegistrationDetail());
            store.dispatch(resetAgeVerification());
            store.dispatch(jkoaPurchaseNo());
            store.dispatch(resetCheckout());
            store.dispatch(resetOrderData());
        }
    });
}

export default storeResetFunction;